import {renderElement} from "../../utils/common";

type SubscribeTemplateType = {id: string, name: string, img: string}

const getSubscribeItemTemplate = ({id, name, img}: SubscribeTemplateType) => `<li class="staff__item" data-id="${id}">
  <img src="${img}" width="22" height="22" alt="Иконка пользователя ${name}">
</li>`;

class SubscribesSelect {
  private taskElement: HTMLElement;
  private readonly openSubscribersButton: HTMLButtonElement;
  private readonly subscribersModalElement: HTMLElement;
  private readonly currentSubscribersList: HTMLElement;

  private currentSubscribersElements: number[] = [];

  callback: {
    openSubscribersListClick?: (evt: Event) => void;
    windowClick?: (evt: Event) => void;
    openSubscribersButtonClick?: () => void;
  } = {};

  constructor(taskElement: HTMLElement) {
    try {
      this.taskElement = taskElement;
      this.openSubscribersButton = this.taskElement.querySelector(`.js-open-subscribers`)!;
      this.subscribersModalElement = this.taskElement.querySelector(`.js-subscribers-modal`)!;
      this.currentSubscribersList = this.taskElement.querySelector(`.js-current-subs-list`)!;

      this.init();

      this.watchOpenSubscribersButtonClickHandler = this.watchOpenSubscribersButtonClickHandler.bind(this);
      this.watchSubscribersListClickHandler = this.watchSubscribersListClickHandler.bind(this);
      this.watchWindowClick = this.watchWindowClick.bind(this);
    } catch (e) {
      console.log(e);
    }
  }


  private init() {
    Array.from(this.currentSubscribersList.children)
      .forEach((element: HTMLElement) => this.currentSubscribers.push(+element.dataset.id!));

    this.currentSubscribers.forEach((subId) => {
      const items: NodeListOf<HTMLElement> = this.subscribersModalElement.querySelectorAll(`.modal__item`)!;
      const findingElement = Array.from(items)
        .find((element: HTMLElement) => +element.dataset.id! === subId)!;

      findingElement?.classList.add(`modal__item--selected`);
    });
  }

  private enabledNewSubscribers() {
    this.currentSubscribers.forEach((subId) => {
      const items: NodeListOf<HTMLElement> = this.subscribersModalElement.querySelectorAll(`.modal__item`);
      const findingElement: HTMLElement | undefined = Array.from(items)
        .find((element: HTMLElement) => +element.dataset.id! === subId);
      findingElement?.classList.add(`modal__item--selected`);

      if (findingElement) {
        const currentSub: HTMLElement | undefined = (Array.from(
          (this.currentSubscribersList.children)) as HTMLElement[])
          .find((item) => +item.dataset.id! === +findingElement.dataset.id!);

        if (!currentSub) {
          renderElement(this.currentSubscribersList,
            getSubscribeItemTemplate(findingElement.dataset as SubscribeTemplateType));
        }
      }
    });
  }

  getModalElement() {
    return this.subscribersModalElement;
  }

  getOpenButtonElement() {
    return this.openSubscribersButton;
  }

  toggleActivityModalSubsStatus() {
    this.subscribersModalElement.classList.toggle(`modal--show`);
  }

  closeModalSubsStatus() {
    this.subscribersModalElement.classList.remove(`modal--show`);
  }

  toggleActivitySubscribeElement(element) {
    element.classList.toggle(`modal__item--selected`);
  }

  disabledSubscribers(newSubscribers) {
    this.currentSubscribers.forEach((subId) => {
      const items: NodeListOf<HTMLElement> = this.subscribersModalElement.querySelectorAll(`.modal__item`);

      const findingElement: HTMLElement | undefined = Array.from(items)
        .find((element) => +element.dataset.id! === subId && !newSubscribers.includes(+element.dataset.id!));

      findingElement?.classList.remove(`modal__item--selected`);

      const currentSub: HTMLElement | undefined = (Array.from((this.currentSubscribersList.children)) as HTMLElement[])
        .find((item) => +item.dataset.id! === +findingElement?.dataset.id!);

      currentSub?.remove();
    });
  }

  changeSubscribers(element) {
    if (element.classList.contains(`modal__item--selected`)) {
      this.currentSubscribers.push(+element.dataset.id);
    } else {
      const index = this.currentSubscribers.indexOf(+element.dataset.id);

      if (index !== -1) {
        this.currentSubscribers.splice(index, 1);
      }
    }
  }

  renderSubscriber(element) {
    const {dataset} = element;

    if (element.classList.contains(`modal__item--selected`)) {
      renderElement(this.currentSubscribersList, getSubscribeItemTemplate(dataset));
    } else {
      const items = (Array.from(this.currentSubscribersList.children) as HTMLElement[]);

      const currentSub = items
        .find((item) => +item.dataset.id! === +dataset.id);

      if (currentSub) {
        currentSub.remove();
      }
    }
  }

  get currentSubscribers() {
    return this.currentSubscribersElements;
  }

  set currentSubscribers(subscribers) {
    this.currentSubscribersElements = subscribers;
    this.enabledNewSubscribers();
  }

  watchSubscribersListClickHandler(evt: Event) {
    this.callback.openSubscribersListClick && this.callback.openSubscribersListClick(evt);
  }

  watchOpenSubscribersButtonClickHandler() {
    this.callback.openSubscribersButtonClick && this.callback.openSubscribersButtonClick();
  }

  watchWindowClick(evt: Event) {
    this.callback.windowClick && this.callback.windowClick(evt);
  }

  setWindowClickHandler(callback: ((evt: Event) => void) | undefined) {
    this.callback.windowClick = callback;
    window.addEventListener(`click`, this.watchWindowClick);
  }

  setSubscribersListClickHandler(callback: ((evt: Event) => void) | undefined) {
    this.callback.openSubscribersListClick = callback;
    this.subscribersModalElement.addEventListener(`click`, this.watchSubscribersListClickHandler);
  }

  setOpenSubscribersButtonClickHandler(callback: (() => void) | undefined) {
    this.callback.openSubscribersButtonClick = callback;
    this.openSubscribersButton.addEventListener(`click`, this.watchOpenSubscribersButtonClickHandler);
  }
}

export {SubscribesSelect};
